import { render, staticRenderFns } from "./point-detail.vue?vue&type=template&id=5ee57fed&"
import script from "./point-detail.vue?vue&type=script&lang=js&"
export * from "./point-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports